import { useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { useLocation, useParams } from 'react-router-dom'
import {
  ContractorPortalFetchPartner,
  FetchPartnerPublicInfo,
  FetchPartner,
} from 'src/constants/actionTypes'
import { PartnerPublicInfo } from 'src/interfaces/partner'
import { getPartner } from 'src/selectors/partner'
import { createAsyncAction } from 'src/utils/reduxUtils'
import { useAuthTokens } from './useAuthTokens'

export const useRemoteTheme = () => {
  const params = useParams()
  const dispatch = useDispatch()
  const location = useLocation()

  const partner = useSelector(getPartner)

  const { authToken, contractorPortalAuthToken } = useAuthTokens()

  const partnerName = params?.partnerName || partner?.name || ''

  useEffect(() => {
    if (!partnerName) {
      if (!location.pathname.includes('/contractor/') && authToken) {
        dispatch(FetchPartner.request())
      }

      if (location.pathname.includes('/contractor/') && contractorPortalAuthToken) {
        dispatch(ContractorPortalFetchPartner.request())
      }

      return
    }

    const fetchedPartnerPublicInfo = async () => {
      const partnerPublicInfo: PartnerPublicInfo = await createAsyncAction(
        dispatch,
        FetchPartnerPublicInfo.request({ partnerName }),
      )

      if (partnerPublicInfo?.collectDataStyles) {
        Object.entries(partnerPublicInfo.collectDataStyles).forEach(([key, value]) => {
          document.documentElement.style.setProperty(key, value)
        })
      }
    }

    fetchedPartnerPublicInfo()
  }, [partnerName, authToken, contractorPortalAuthToken, location.pathname])
}
